import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function hasFeature(
  features: string[] | undefined,
  code: string,
): boolean {
  const list = features ?? [];
  if (list.includes(code)) return true;
  // Legacy umbrella package for all report screens
  if (code.startsWith('reports_') && list.includes('reports')) return true;
  return false;
}

/** Blocks tenant routes when the feature is not enabled for the office. */
export function FeatureRoute({ feature }: { feature: string }) {
  const { user, isSuperAdmin } = useAuth();
  if (isSuperAdmin && !user?.supportLogin) {
    return <Outlet />;
  }
  if (!hasFeature(user?.features, feature)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
